import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { MatSelectionList } from '@angular/material/list';

import { TrueFalseQuestion } from '../../models';

@Component({
  selector: 'yes-no-question-list',
  templateUrl: './yes-no-question-list.component.html',
  styleUrls: ['./yes-no-question-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class YesNoQuestionListComponent implements OnInit {
  
  questionsList: MatSelectionList;
  
  @Input()
  questions: TrueFalseQuestion[];

  constructor() { }

  ngOnInit() {
    
  }

  changeSelection(event) {
    let changedQuestion = this.questions.find(
      q => q.QuestionId === event.option.value
    );
    if (changedQuestion) {
      changedQuestion.Selected = event.option.selected;
    }
  }


}
